export const GEMINI_FLASH_MODEL = "gemini-3.7-flash";

/**
 * 과거 브라우저/서버 설정에 남은 Gemini 생성 모델을 현행 운영 모델로 승계한다.
 * 비 Gemini 공급자 선택은 그대로 보존한다.
 */
export const normalizeGeminiGenerationModel = (
  model,
  fallback = GEMINI_FLASH_MODEL,
) => {
  const value = typeof model === "string" ? model.trim() : "";
  if (!value) return fallback;
  return value.startsWith("gemini-") ? GEMINI_FLASH_MODEL : value;
};

export const normalizeGeminiGenerationModels = (
  models,
  fallback = [GEMINI_FLASH_MODEL],
) => {
  const values = Array.isArray(models) ? models : [];
  const normalized = values
    .map((model) => normalizeGeminiGenerationModel(model, ""))
    .filter(Boolean);
  const unique = [...new Set(normalized)];
  return unique.length > 0 ? unique : fallback;
};
